export const isDesktopShell = (): boolean =>
    typeof (window as any).chrome?.webview !== 'undefined';